export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-gradient-to-br from-background-100 to-background-200 border border-background-300/60 p-8 md:p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-customer-service-2-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto mb-6 leading-relaxed">
            如有影片推荐、问题反馈或合作咨询，欢迎通过以下方式联系我们。丫丫影院团队将尽快回复您的每一条留言。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="mailto:contact@yaya.com"
              className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-1.5"></i>发送邮件
            </a>
            <a
              href="#faq"
              className="w-full sm:w-auto px-6 py-3 border-2 border-secondary-300 text-secondary-700 font-medium rounded-full hover:bg-secondary-50 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-questionnaire-line mr-1.5"></i>查看常见问题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}